import { get } from '@/util/helpers/ajax-helpers';
import { completed } from './helpers';
import { USER_ACTION_FIRED, USER_ACTIONS_LOADED } from './constants';

export function fireUserAction(action) {
  return (dispatch) => {
    dispatch(completed(USER_ACTION_FIRED, { action }));
  };
}

export function loadUserActions() {
  return (dispatch) => {
    get('loading onboarding', '/actions').then((json) => {
      dispatch(completed(USER_ACTIONS_LOADED, json));
    });
  };
}
